import { render, staticRenderFns } from "./configOverrideButton.vue?vue&type=template&id=2c1a99e4"
import script from "./configOverrideButton.vue?vue&type=script&lang=js"
export * from "./configOverrideButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports